<template>
    <qd-admin-auth pid="314">
        <div
            v-spinner="loading"
            class="power-setting"
        >
            <v-spinner :opacity="0.5">
                加载中...
            </v-spinner>
            <template v-if="!loading">
                <v-page-header slot="extra" title="应用菜单设置">
                    <lamp-tip>
                        <div class="power-setting-tip-item">
                            - 本页面设置的是员工在账户中心，对当前应用各模块的查看管理权限
                        </div>
                        <div class="power-setting-tip-item">
                            - 如需设置专家在企微“专家工作台”的接待权限，请使用管理员账户到<a
                                :href="weworkLoginUrl"
                                target="__blank"
                            >企微后台</a>设置“可见范围”，并且在企点账户中心各应用的机器人转人工条件中设置接待者
                        </div>
                        <div class="power-setting-tip-item">
                            - 对所有应用的整体管理权限请在<a
                                href="/mng/role"
                                target="__blank"
                            >企业管理-权限角色</a>设置
                        </div>
                    </lamp-tip>
                </v-page-header>
                <PowerSettingBlock v-model="powerSetting" />
                <v-footer-actionbar v-if="!isEmptyPower" size="large" :layout="layout" class="power-setting-footer" @confirm="handleSave" @cancel="handleReset" />
            </template>
            <aside-nav :visible="visible" />
        </div>
    </qd-admin-auth>
</template>

<script>
import LampTip from '@/components/lamp-tip';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import { getWeorkLoginPage } from 'src/cgi/getWeworkInfo';
import PowerSettingBlock from './components/PowerSettingBlock';
import { ERR_APP_ID_CODE, ERR_APP_ID_CODE_JUMP_URL } from '../const';
import { getAppId } from '../utils/helper';
import AsideNav from '@/components/aside-nav';

export default {
    components: {
        PowerSettingBlock,
        AsideNav,
        LampTip,
    },
    data() {
        return {
            powerSetting: [],
            powerSettingBak: [],
            loading: false,
            isSaving: false,
            visible: true,
            weworkLoginUrl: '',
        };
    },
    computed: {
        isModify() {
            return !isEqual(this.powerSetting, this.powerSettingBak);
        },
        isEmptyPower() {
            return this.powerSetting.length === 0;
        },
        layout() {
            return {
                primary: {
                    text: '保存',
                    kind: 'primary',
                    loading: this.isSaving,
                },
                cancel: {
                    text: '返回上一次保存',
                    disabled: !this.isModify,
                },
            };
        },
    },
    created() {
        this.visible = true;
        this.fetchPowerScopeList();
        getWeorkLoginPage().then((url) => {
            this.weworkLoginUrl = url;
        });
    },
    methods: {
        handleSave() {
            this.isSaving = true;
            const data = {
                app_id: getAppId(),
                permission_items: this.powerSetting.map(item => ({
                    permission_id: item.permission_id,
                    name: item.name,
                    dep_id: item.permission_scope.filter(itm => itm.type === 0).map(itm => itm.id),
                    kfext: item.permission_scope.filter(itm => itm.type === 1).map(itm => itm.id),
                })),
            };
            this.$ajax
                .gatewayPost('/v1/basic.privilege.func_privilege.FuncPrivilege/AppPermissionConfig', {
                    ...data,
                })
                .then((res) => {
                    this.isSaving = false;
                    if (res.code === 0) {
                        this.$message('保存成功', 'success');
                        // this.powerSettingBak = cloneDeep(this.powerSetting);
                        // 刷新页面，更新左侧菜单
                        window.location.reload();
                    } else {
                        this.$message.error(res.message || '网路错误');
                    }
                })
                .catch((err) => {
                    this.isSaving = false;
                    throw err;
                });
        },
        handleReset() {
            this.powerSetting = cloneDeep(this.powerSettingBak);
        },
        fetchPowerScopeList() {
            this.loading = true;
            this.$ajax
                .gatewayGet('/v1/basic.privilege.func_privilege.FuncPrivilege/AppPermission', {
                    params: {
                        app_id: getAppId(),
                    },
                })
                .then((res) => {
                    this.loading = false;
                    const { code } = res;
                    if (code === 0) {
                        this.powerSetting = res.data.permission_items;
                        this.powerSettingBak = cloneDeep(res.data.permission_items);
                    } else if (code === ERR_APP_ID_CODE) {
                        window.location.href = ERR_APP_ID_CODE_JUMP_URL;
                    } else {
                        this.$message.error(res.message || '网路错误');
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    throw err;
                });
        },
    },
};
</script>

<style lang="less">
@import './styles/app.less';
</style>
